import Vue from "vue";
import VueRouter from "vue-router";
import Register from "@/pages/LoginRegister/Register";
import Login from "@/pages/LoginRegister/Login";
import RegisterAndLogin from "@/pages/LoginRegister/RegisterAndLogin";
import ImageUploadTest from "@/pages/ImageUploadTest";
import WebIndex from "@/pages/CarShow/WebIndex";
import axios from "axios";
import store from "@/store";
import BuyCar from "@/components/BuyCar";
import SellCar from "@/components/SellCar";
import UserInfo from "@/components/UserInfo";
import UserOrder from "@/components/UserOrder";
import MyCar from "@/components/MyCar";
import ChangeCarInfo from "@/components/ChangeCarInfo";
import CarInfo from "@/components/CarInfo";
import SociableSuccess from "@/pages/LoginRegister/SociableSuccess";

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            //默认路由
            path: "/",
            redirect: "/enter/login"
        },
        {
            path: "/enter",
            component: RegisterAndLogin,
            children: [
                {
                    path: "register",
                    component: Register,
                    meta: {
                        title: "注册"
                    }
                },
                {
                    path: "login",
                    component: Login,
                    meta: {
                        title: "登录"
                    }
                }
            ]
        },
        {
            path: '/successLogin',
            component: SociableSuccess,
            meta:{
                title: "跳转"
            }
        },
        {
            path: "/index",
            component: WebIndex,
            children:[
                {
                    path: "buy",
                    component: BuyCar,
                    meta: {
                        title: "买车"
                    }
                },
                {
                    path: "sell",
                    component: SellCar,
                    meta: {
                        title: "卖车"
                    }
                },
                {
                    path: "info",
                    component: UserInfo,
                    meta: {
                        title: "个人信息"
                    }
                },
                {
                    path: "order",
                    component: UserOrder,
                    meta: {
                        title: "我的订单"
                    }
                },
                {
                    path: "mycar",
                    component: MyCar,
                    meta: {
                        title: "我的上架"
                    }
                },
                {
                    path: "change",
                    component: ChangeCarInfo,
                    meta: {
                        title: "修改汽车信息"
                    }
                },
                {
                    path: "carInfo/",
                    component: CarInfo,
                    meta: {
                        title: "汽车详情"
                    }
                }


            ],
        },

        {
            path: "/testupload",
            component: ImageUploadTest,
            meta: {
                title: "图片上传测试"
            }
        }

    ]
})
//
//前置路由守卫
router.beforeEach((to, from, next) => {

    //设置页面title
    if (to.meta.title) {
        document.title = to.meta.title
    }

    //判断用户要去哪个页面
    if (to.path === '/enter/register' || to.path === '/enter/login' || to.path === '/' || to.path === '/successLogin') {
        //直接放行
        next();
    } else {
        //判断用户是否有token
        let userToken = localStorage.getItem("token");

        /////此处token应该和vuex里面的token数据进行比较，防止用户篡改localStorage中的token数据绕过验证
        ////但是vuex里面的数据一刷新就没了，怎么办？
        if (userToken === null || userToken === '') {
            //token不正确
            alert('请先登录');
            return next('/enter/login');
        } else {

            //获取用户信息，存入vuex
            let id = localStorage.getItem("id")
            let token = localStorage.getItem("token")

            var fd = new FormData()
            let obj = {
                id: id,
                token: token
            }
            fd.append("info", JSON.stringify(obj))
            axios.post("/login/getUserInfo", fd).then(res => {
                if (res.data.code == 0) {
                    //将得到的用户信息存入vuex
                    store.dispatch('UserInfo/changeuserinfo'
                        , {
                            user: res.data.data.userInfo
                        })
                    if(to.path === '/index/sell' || to.path === '/index/carInfo'){
                        if(res.data.data.userInfo.email === null){
                            alert('请绑定邮箱')
                            return next('/index/info');
                        }
                    }

                    next()

                    // console.log(res.data.data.userInfo.email)
                    // next()
                }else {
                    // alert(res.data.message)
                    alert('登录已失效')
                    return next('/enter/login');
                }
            })

            //放行
            // next();
        }
    }

})

export default router;
